import axios from '@/axiosInstance.ts'
import {ResponseTypeParam} from '@/types.ts'

export interface HttpRateOptions {
    payload: {
        rating: number
    }
}
export const httpRate = ({payload}: HttpRateOptions) => axios.post('rate', payload)

interface HttpGetPaymentsDatesOptions {
    params: ResponseTypeParam & {
        limit: number
        page: number
        from: string
        to: string
    }
}
export const httpGetPaymentsDates = ({params}: HttpGetPaymentsDatesOptions) =>
    axios.get('/navigate/photographers/photographer-payments/payment-dates', {params})

interface HttpGetFreelancerPaymentsOptions {
    params: ResponseTypeParam & {
        date: string
    }
}
export const httpGetFreelancerPayments = ({params}: HttpGetFreelancerPaymentsOptions) => {
    return axios.get('/photographer-payments', {params})
}

interface HttpGetLastFreelancerPaymentsOptions {
    params: ResponseTypeParam & {
        limit: number
        page: number
    }
}
export const httpGetLastFreelancerPayments = ({params}: HttpGetLastFreelancerPaymentsOptions) => {
    return axios.get('/navigate/photographers/home/payments', {params})
}
